/**
* DevExpress Analytics (property-grid\widgets\fonteditor\metadata.js)
* Version:  21.2.13
* Build date: Apr 10, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var editorsInfo_1 = require("../editorsInfo");
var _fonts_1 = require("./_fonts");
var _model_1 = require("./_model");
exports.fontName = {
    propertyName: 'family', displayName: 'Font Name', localizationId: 'AnalyticsCoreStringId.FormatFontName',
    editor: editorsInfo_1.editorTemplates.getEditor('combobox'), values: _fonts_1.availableFonts
};
exports.fontSize = {
    propertyName: 'size', displayName: 'Size', localizationId: 'AnalyticsCoreStringId.Font.Size', editor: editorsInfo_1.editorTemplates.getEditor('numeric')
};
exports.fontSizeUnit = {
    propertyName: 'unit', displayName: 'Unit', localizationId: 'AnalyticsCoreStringId.Font.Unit', editor: editorsInfo_1.editorTemplates.getEditor('combobox'),
    valuesArray: _model_1.availableUnits
};
exports.fontInfo = [
    exports.fontName,
    exports.fontSize,
    exports.fontSizeUnit,
    { propertyName: 'modificators', editor: editorsInfo_1.editorTemplates.getEditor('modificators') },
];
